import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';
import qs from 'qs';

const queryFn = ({ contractId }: QueryParams) => {
    const querystring = qs.stringify({ contractId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getStoredFilterBulkAssignOrRemoveTags${querystring}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};

export const useQueryGetStoredFilterBulkAssignOrRemoveTags = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys]>({
        queryKey: ['getStoredFilterBulkAssignOrRemoveTags'],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.contractId),
    });
};

interface QueryParams {
    contractId?: number;
}

export interface QueryResponse {
    info: IToolTip;
    tagAssignRule: {
        lastRunActivities: number;
        id: number;
        ruleRank: number;
        appliedFilter: string;
        LastRunActivities: number;
        updatedBy: string;
        updatedByName: string;
        lastUpdate: number;
        assignee: string;
        assigneeName: string;
    }[];
}
